/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/reducerLocationStates.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers for States
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Monday, May 13, 2019 - 04:47:35 PM (CST)
 *  
 *  Notes:
 *
 *  
 *  Revisions:
 *      05/13/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    STATE_LIST_CONTAINER_LOADED,
    STATE_LIST_CONTAINER_UNLOADED,
    STATE_LIST_TABLE_LOADED,
    STATE_LIST_TABLE_UNLOADED,

    STATE_LIST_CHANGE_GROUP,

    STATE_SELECT_ROW,
    STATE_ADD,
    STATE_EDIT,
    STATE_DELETE,
    STATE_OPEN_WARNING,
    STATE_CLOSE_WARNING,
    STATE_DELETE_DISABLE,

    STATE_EDIT_CONTAINER_LOADED,
    STATE_EDIT_CONTAINER_UNLOADED,
    STATE_EDIT_FORM_LOADED,
    STATE_EDIT_FORM_UNLOADED,
    STATE_EDIT_DATA_LOAD,
    STATE_EDIT_CONTAINER_SUBMIT,
    STATE_EDIT_CONTAINER_CANCEL
} from '../constants/actionTypeLocationStates';

const defaultState = {
    refreshList: false,
    danger: false,
    stateid: 0,
    countryid: 0,
    name: '',
    abbreviation: '',
    createdate: '',
    modifydate: ''
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case STATE_LIST_CONTAINER_LOADED:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                states: action.payload[0] ? action.payload[0].records : null,
                countries: action.payload[1] ? action.payload[1].records : null
            }
        case STATE_LIST_CHANGE_GROUP:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                states: action.payload[0] ? action.payload[0].records : null
            }
        case STATE_LIST_TABLE_LOADED:
            return {
                ...state
            }
        case STATE_SELECT_ROW:
            return {
                ...state,
                stateid: action.id
            }
        case STATE_ADD:
            return {
                ...state
            }
        case STATE_EDIT:
            return {
                ...state,
                stateid: action.id
            }
        case STATE_DELETE:
            return {
                ...state,
                stateid: null
            }
        case STATE_DELETE_DISABLE:
            return {
                ...state,
                disableDelete: action.disabled
            }
        case STATE_OPEN_WARNING:
            return {
                ...state,
                danger: true
            }
        case STATE_CLOSE_WARNING:
            return {
                ...state,
                danger: false
            }
        case STATE_EDIT_CONTAINER_LOADED:
        case STATE_EDIT_DATA_LOAD:
            return {
                ...state,
                stateid: action.payload[0] ? action.payload[0].stateid : 0,
                countryid: action.payload[0] ? action.payload[0].countryid : 0,
                country: action.payload[1] ? action.payload[1].name : action.payload[0] ? action.payload[0].country : '',
                name: action.payload[0] ? action.payload[0].name : '',
                abbreviation: action.payload[0] ? action.payload[0].abbreviation : '',
                createdate: action.payload[0] ? action.payload[0].createdate : '',
                modifydate: action.payload[0] ? action.payload[0].modifydate : ''
            }
        case STATE_EDIT_FORM_LOADED:
            return {
                ...state
            }
        case STATE_EDIT_CONTAINER_SUBMIT:
            return {
                ...state
            }
        case STATE_EDIT_CONTAINER_CANCEL:
            return {
                ...state
            }
        case STATE_LIST_CONTAINER_UNLOADED:
        case STATE_LIST_TABLE_UNLOADED:
        case STATE_EDIT_CONTAINER_UNLOADED:
        case STATE_EDIT_FORM_UNLOADED:
            return {};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/reducerLocationStates.js